// api.request.js
import HttpRequest from "./axios";
// 这里写的是请求路径的ip或者域名
const baseUrl =
  process.env.NODE_ENV === "development"
    ? "/api" : window.location.origin + "/prod-api";
const axios = new HttpRequest(baseUrl);
export default axios;


// WEBPACK FOOTER //
// ./src/http/api.js